import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

export default function MostReadWidget() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/articles/most-read", { params: { limit: 5, hours: 24 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section
      data-testid="most-read-widget"
      className="rounded-md border p-4"
      style={{ borderColor: "var(--border)", background: "var(--surface)" }}
    >
      <div className="flex items-center gap-2 mb-4 border-b pb-3" style={{ borderColor: "var(--border)" }}>
        <TrendingUp size={16} className="accent-text" />
        <h2 className="overline">LO MÁS LEÍDO · 24H</h2>
      </div>
      <ol className="space-y-4">
        {items.map((a, i) => (
          <li key={a.slug}>
            <Link
              to={`/nota/${a.slug}`}
              data-testid={`most-read-item-${i + 1}`}
              className="flex items-center gap-3 group"
            >
              <span
                className="font-headline text-3xl leading-none w-8 text-center shrink-0 accent-text"
                data-testid={`most-read-rank-${i + 1}`}
              >
                {i + 1}
              </span>
              <div className="w-16 h-12 rounded-sm overflow-hidden shrink-0" style={{ background: "var(--surface-2)" }}>
                {a.featured_image && (
                  <img src={a.featured_image} alt={a.title} loading="lazy" className="w-full h-full object-cover" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                {a.category_slug && (
                  <span className="overline accent-text block mb-0.5">{a.category_slug.toUpperCase()}</span>
                )}
                <h3 className="text-sm font-semibold leading-snug line-clamp-2 group-hover:opacity-80" style={{ color: "var(--text)" }}>
                  {a.title}
                </h3>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}
